import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import { T as TouchLinkButton, a as TouchLinkAnchor } from './TouchLink.styles-2e6f91b2.js';
import { T as TouchLinkBody } from './TouchLinkBody-e96bc882.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-f853b17a.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-39f30e88.js';

const TouchLink = ({
  children,
  href,
  onClick,
  taktId,
  taktValue
}) => {
  if (onClick) {
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('touch-link')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(TouchLinkButton, _extends({
      onClick: onClick
    }, getDataTaktAttributes()), /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children)));
  }
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('touch-link')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(TouchLinkAnchor, _extends({
    href: href
  }, getDataTaktAttributes()), /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children)));
};
TouchLink.propTypes = {
  /**
   * The React nodes that are rendered by the Touchlink.
   */
  children: PT.node.isRequired,
  /**
   * Use to add a link to TouchLink.
   */
  href: PT.string,
  /**
   * Use to add a button to TouchLink.
   */
  onClick: PT.func
};
TouchLink.defaultProps = {
  href: undefined,
  onClick: undefined
};
TouchLink.displayName = 'TouchLink';
var TouchLink$1 = TouchLink;

export { TouchLink$1 as T };
//# sourceMappingURL=TouchLink-65241d70.js.map
